import { Heading } from "@/components/catalyst/Heading";
import { TabBarSkeleton } from "@/components/TabBarSkeleton";
import { ReferralLinkDetailSkeleton } from "./ReferralLinkDetailSkeleton";

/**
 * Full-page skeleton for the Referral Link Detail route's pendingComponent.
 * Shows heading, tab bar, and the default Edit tab skeleton.
 */
export function ReferralLinkDetailPageSkeleton() {
	return (
		<>
			<div className="flex items-center justify-between mb-8">
				<Heading>Edit Referral Link</Heading>
			</div>
			<TabBarSkeleton tabWidths={[40, 90]} />
			<div className="mt-4 py-4">
				<ReferralLinkDetailSkeleton />
			</div>
		</>
	);
}
